module.exports = __webpack_public_path__ + "src/assets/games/9/95.jpg";